var app = angular.module('harriApp');


app.factory('mediaViewerData', ["httpHelper", function (httpHelper) {

    var data = {};

    data.setData = function(d){
        data['media_data'] = d;
    };

    data.media = function(){
        return data['media_data'];
    };

    data.mediaGallery = function(id){
       return httpHelper.g('user_gallery/'+id);
    };


    return data;
}]);

